<template>
  <div class="main-page">
    <template v-if="showHeader">
      <section class="page-section">
        <div class="container-fluid">
          <div class="grid justify-content-between">
            <div class="col">
              <div class="">
                <div class="text-3xl font-bold">Transactions Details</div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <hr />
    </template>
    <section class="page-section pt-2">
      <div class="container-fluid">
        <div class="grid">
          <div class="col comp-grid">
            <div class="">
              <div class="">
                <div>
                  <div class="relative-position" style="min-height: 100px">
                    <template v-if="pageReady">
                      <div class="grid">
                        <div class="col-12">
                          <div class="" :class="{ card: !isSubPage }">
                            <div class="grid align-items-center">
                              <div class="col">Transaction Id:</div>
                              <div class="col font-bold">
                                {{ item.transaction_id }}
                              </div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">Customer:</div>
                              <div class="col font-bold">
                                <Button
                                  class="p-button-link p-0 text-left"
                                  icon=""
                                  :label="item.customers_name"
                                  v-if="item.customer_id"
                                  @click="
                                    app.navigateTo(
                                      `/customers/view/${item.customer_id}`
                                    )
                                  "
                                />
                              </div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">GAccount:</div>
                              <div class="col font-bold">
                                <Button
                                  class="p-button-link p-0 text-left"
                                  icon=""
                                  label="G-Account Details"
                                  v-if="item.meter_id"
                                  @click="
                                    app.openPageDialog({
                                      page: 'meters/view',
                                      url: `/meters/view/${item.meter_id}`,
                                      closeBtn: true,
                                      position: 'bottom',
                                    })
                                  "
                                />
                              </div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">Customer Number:</div>
                              <div class="col font-bold">
                                {{ item.gwcl_customer_number }}
                              </div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">Telephone:</div>
                              <div class="col font-bold">{{ item.msisdn }}</div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">Network:</div>
                              <div class="col font-bold">
                                {{ item.network }}
                              </div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">Payer Name:</div>
                              <div class="col font-bold">
                                {{ item.payer_name }}
                              </div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">Payment Method:</div>
                              <div class="col font-bold">
                                {{ $utils.upper(item.payment_method) }}
                              </div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">Payment Status:</div>
                              <div class="col">
                                <span
                                  v-if="item.payment_status == 'success'"
                                  class="font-medium text-green-500"
                                  >{{
                                    $utils.capitalize(item.payment_status)
                                  }}</span
                                >
                                <span
                                  v-else-if="item.payment_status == 'failed'"
                                  class="font-medium text-pink-500"
                                  >{{
                                    $utils.capitalize(item.payment_status)
                                  }}</span
                                >
                                <span
                                  v-else
                                  class="font-medium text-yellow-500"
                                  >{{
                                    $utils.capitalize(item.payment_status)
                                  }}</span
                                >
                              </div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">Amount (GHS):</div>
                              <div class="col font-bold">
                                {{ item.actual_amount }}
                              </div>
                            </div>
                            <hr />
                            <!-- <div class="grid align-items-center">
                              <div class="col">Service Charge (GHS):</div>
                              <div class="col font-bold">
                                {{ item.transaction_charge }}
                              </div>
                            </div>
                            <hr /> -->
                            <div class="grid align-items-center">
                              <div class="col">Date Created:</div>
                              <div class="col font-bold">
                                {{ $utils.humanDatetime(item.date_created) }}
                              </div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">Last Updated:</div>
                              <div class="col font-bold">
                                {{ $utils.humanDatetime(item.date_updated) }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                    <template v-if="loading">
                      <div>
                        <table class="p-datatable-table w-full">
                          <tbody>
                            <tr v-for="n in 5" :key="n">
                              <td class="text-left" style="width: 100%">
                                <Skeleton height="3rem" class="m-2" />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script setup>
import { toRefs, onMounted } from "vue";
import { utils } from "@/utils";
import { useApp } from "@/composables/app.js";
import { useViewPage } from "@/composables/viewpage.js";
//[--PAGE-IMPORT-STATEMENT--]
const props = defineProps({
  id: [String, Number],
  primaryKey: {
    type: String,
    default: "payment_history_id",
  },
  pageName: {
    type: String,
    default: "payment_history",
  },
  routeName: {
    type: String,
    default: "payment_historyview",
  },
  apiPath: {
    type: String,
    default: "payment_history/view",
  },
  editButton: {
    type: Boolean,
    default: true,
  },
  deleteButton: {
    type: Boolean,
    default: true,
  },
  exportButton: {
    type: Boolean,
    default: true,
  },
  titleBeforeDelete: {
    type: String,
    default: "Delete record",
  },
  msgBeforeDelete: {
    type: String,
    default: "Record deleted successfully",
  },
  msgAfterDelete: {
    type: String,
    default: "Record deleted successfully",
  },
  showHeader: {
    type: Boolean,
    default: true,
  },
  showFooter: {
    type: Boolean,
    default: true,
  },
  isSubPage: {
    type: Boolean,
    default: false,
  },
});
const app = useApp(props);
const page = useViewPage(props); // page hook
//page state
const {
  item, // current record from store - Object
  loading, // api loading state
  pageReady, // api data loaded successfully
} = toRefs(page.state);
//page computed propties
const {
  apiUrl, // page current api path
  currentRecord, // current page record  - Object
} = page.computedProps;
//page methods
const {
  load, // load data from api
  deleteItem, // deleted current record
  exportPage, // export page records - args = (exportFormats, apiUrl, pageName)
  moveToNextRecord, // load next record from api
  moveToPreviousRecord, // load previous record from api
} = page.methods;
function getActionMenuModel(data) {
  return [];
}
onMounted(() => {
  const pageTitle = "Payment History Details";
  app.setPageTitle(props.routeName, pageTitle); // set browser page title
  load();
});
</script>
<style scoped></style>
<style scoped></style>
